import { BridgePosition, SeatPosition } from '../../app/types';
import { GameEngine, SeatPosFor, convertIntToBridgePosition } from '../game-engine-helper';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import { bridgePos, bridgeWarTitleMap } from '../../app/defaults';
import { bridgeWarGui } from '../../env';
import { claimButton, concedeButton, undoButton } from '../buttonsState';
import { popMessage } from '../../utils/shark-helper';
import { sfsService } from '../sfs-service';

export function MID_TIME_TO_PLAY(cmdObj: SFSObject, sender: GameEngine) {
    handleTrickClosure(cmdObj, sender);
    const currentPlayerId: number = cmdObj.getInt(SFSVAR.SFSGAME_CURENT_PLAYER);
    const currentPlayer: BridgePosition = convertIntToBridgePosition(currentPlayerId);
    const bridgePosition = bridgePos(currentPlayerId);

    updateEngineInterfaceState(sender, bridgePosition);
    resetSeatData(sender);
    setSeatDataForCurrentPlayer(sender, bridgePosition);

    sender.setCurrentPlayer(currentPlayer);

   sender.showButtonsIfNeeded();

    const { urlParams } = sender.props.app;
    const { showWelcome } = sender.props.app.engineStateInterface;
    sender.props.app_updateEngineInterfaceState({ showWelcome: false });

    const atVeryFirstBoard =
        sender.props.table.board.boardNumber === 1 && sender.props.table.tricks[0]?.cardIds.length === 1;
    const resumeGameSelector = [
        {
            title: bridgeWarGui ? bridgeWarTitleMap[urlParams?.['mode']] : 'Welcome back!',
            text: bridgeWarGui
                ? 'Welcome back to the Battlefield! <br/><br/> It is your turn to make a move'
                : 'It is your turn to make a play',
            buttonLabelNext: bridgeWarGui ? 'Resume Battle' : undefined,
            buttonCancel: bridgeWarGui ? undefined : 'Resume Board',
        },
    ];
    if (showWelcome) {
        if (atVeryFirstBoard) {
            if (urlParams?.['mode'] !== 'bwar_c_' && urlParams?.['mode'] !== 'bwar_ex_') {
                const metaData = sfsService.table?.getVariable('meta')?.value as SFSObject;
                sender.props.table_updateTable({
                    bridgeWarGameSelector: [
                        {
                            title: bridgeWarTitleMap[urlParams?.['mode']],
                            text: urlParams?.['mode']
                                ? (sender.props.app.engineStateInterface.lobbyRoom?.getVariable(
                                      SFSVAR.SFSGAME_ROOM_WELCOME_MESSAGE,
                                  ).value as string)
                                : metaData?.getUtfString('welcome'),
                            buttonLabelNext: 'Start Duel',
                        },
                    ],
                });
            } else {
                if (bridgeWarGui) {
                    sender.props.table_updateTable({ bridgeWarGameSelector: resumeGameSelector });
                }
                else {
                    sender.props.app_addModal(popMessage(resumeGameSelector[0].text, resumeGameSelector[0].title, resumeGameSelector[0].buttonCancel));
                }
            }
        } else {
            //We are resuming a game, this is the first time the user is invited to take action
            if (bridgeWarGui) {
                sender.props.table_updateTable({ bridgeWarGameSelector: resumeGameSelector });
            }
            else {
                sender.props.app_addModal(popMessage(resumeGameSelector[0].text, resumeGameSelector[0].title, resumeGameSelector[0].buttonCancel));
            }
        }
    }
}

function handleTrickClosure(cmdObj: SFSObject, sender: GameEngine) {
    if (!cmdObj.containsKey('closetrick') || !cmdObj.getBool('closetrick')) {
        sender.props.table_shouldCloseTrick(false);
    }
}

function updateEngineInterfaceState(sender: GameEngine, currentPlayer: BridgePosition) {
    sender.props.app_updateEngineInterfaceState({
        currentPlayer: currentPlayer,
    });
}

function resetSeatData(sender: GameEngine) {
    Object.values(SeatPosition).forEach((seatPosition) => {
        sender.props.table_setSeatData({
            seatPosition,
            background: undefined,
        });
    });
}

function setSeatDataForCurrentPlayer(sender: GameEngine, currentPlayer: BridgePosition) {
    sender.props.table_setSeatData({
        seatPosition: SeatPosFor(currentPlayer, sender.props.table.seatData[SeatPosition.bottom]),
        isInteractive: true,
        isVisible: true,
        background: '#fce303',
    });
}

